import { createStore } from 'redux'

const initialState = {
  sidebarShow: 'responsive',
  loading: false,
  by_passed: false,
  eventDate: [],
  searchReport: {},
  reportData: { dataSet: [], data: [] },
  searchOperation: {},
  candidateData: { pending: true, data: [] },
  hireSaleData: { pending: true, data: [] },
  slideShow: false,
  approvedList: 0,
  accessSales: {
    'Candidate PC': false,
    'Candidate SAB': false,
    'Candidate Telesales': false,
    'Hired PC': false,
    'Hired SAB': false,
    'Hired Telesales': false,
    'Hired TelesChubb': false,
  },
  username: '',
  confirmEmailDup: false
}

const changeState = (state = initialState, { type, ...rest }) => {
  switch (type) {
    case 'set':
      return { ...state, ...rest }
    case 'loading-on': {
      return { ...state, loading: true }
    }
    case 'loading-off': {
      return { ...state, loading: false }
    }
    case 'setByPassed': {
      return {
        ...state,
        by_passed: rest.byPassed,
      }
    }
    case 'setUsername': {
      return { ...state, username: rest.username }
    }
    case 'setEventDate': {
      return { ...state, eventDate: rest.eventDate }
    }
    case 'setSearchReport': {
      return { ...state, searchReport: rest.searchReport }
    }
    case 'setReportData': {
      return { ...state, reportData: rest.reportData }
    }
    case 'setSearchOperation': {
      return { ...state, searchOperation: rest.searchOperation }
    }
    case 'setCandidateData': {
      return { ...state, candidateData: rest.candidateData }
    }
    case 'setSlideShow': {
      return { ...state, slideShow: rest.slideShow }
    }
    case 'setHireSaleData': {
      return { ...state, hireSaleData: rest.hireSaleData }
    }
    case 'setApprovedList': {
      return { ...state, approvedList: rest.approvedList }
    }
    case 'setAccessSales': {
      return { ...state, accessSales: rest.accessSales }
    }
    case 'setConfirmEmailDup': {
      return { ...state, confirmEmailDup: rest.confirmEmailDup }
    }

    default:
      return state
  }
}

const store = createStore(changeState, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__())
export default store
